/// <reference path="standingAppointments.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.StandingAppointments {
    class StandingAppointmentsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "restServer",
            "Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService",
            "$q",
            "$http",
            "meevo.components.busy.BusyService",
            "$translate",
            "$timeout",
            "AppointmentEditorService",
            "meevo.plugins.appointmentBook.stepOverrideService",
            "$filter"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected restServer: any,
            protected appointmentBookModalService: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
            protected $q: angular.IQService,
            private $http: any,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService,
            protected appointmentEditorService,
            private stepOverrideService,
            private $filter: angular.IFilterService) {

            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                $scope,
                contextParams,
                $state,
                $rootScope,
                shortCutsService);
            $scope.$on('appointmentChanged', (event, args) => {
                var params = args.stateParams;
                if (params && params.stateName === appSettings.ROUTE_NAMES.standingAppointments && params.requireRefresh) {
                    let appointmentsSection = this.context.selectedSection as AppointmentsSection;
                    if (appointmentsSection) {
                        appointmentsSection.search();
                    }
                }
            });
            $scope.$on(Meevo.Components.Common.Messages.BOOK_APPOINTMENT_FOR_CLIENT, (event, args) => {
                if (args.isFromStanding) {
                    let appointmentsSection = this.context.selectedSection as AppointmentsSection;
                    if (appointmentsSection) {
                        appointmentsSection.bookAppointmentSuccess();
                    }
                }
            });
            this.searchContext = this;
        }

        search(performSearchCb) {
            if (!angular.isFunction(performSearchCb)) {
                return;
            }

            this.$timeout(() => performSearchCb(), 100);
        }

        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
            let rc = this;
            rc.busyService.start();
            rc.securityService.checkSection(rc.meevoSecurityKeys.APPOINTMENTS_STANDINGDEFINITION)
                .then(() => {
                    this.context = new StandingAppointmentsContext(this.appSettings,
                        this.dataService,
                        this.modalService,
                        this.identityService,
                        this.loggingService,
                        this.securityService,
                        this.trackingService,
                        this.restServer,
                        this.appointmentBookModalService,
                        this.$q,
                        this.searchContextCriteria,
                        this.$http,
                        this.$translate,
                        this.$timeout,
                        this.$rootScope,
                        this.stepOverrideService,
                        this.$filter,
                        this.appointmentEditorService);
                    super.createContext();
                    this.context.activate(this.selectedItemId, this.initialEditSection, null, this.initialEditSubSection);
                    this.context.deactivate = () => {
                        this.visualState = Model.MaintenanceFormVisualState.Search;
                    }
                })
                .catch(() => {
                    rc.busyService.stop();
                })
                .finally(() => {
                    rc.busyService.stop();
                });
        }

        async applyParams(params) {
            await super.applyParams(params);

            if (Model.Guard.isNothing(this.context))
                return;
            if (Model.Guard.isSomething(params) && Model.Guard.isSomething(params.id) && Model.Guard.isSomething(params.initialEditSection) ) {
                this.context.activate(params.id, params.initialEditSection, null, null);
            }
        }
    }


    angular.module("meevo.plugins.standingAppointments")
    .controller("meevo.plugins.standingAppointments.StandingAppointmentsController", StandingAppointmentsController);
}